var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Manage Installations ")]),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.items
            },
            scopedSlots: _vm._u([
              {
                key: "item.softurl",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: item.softurl,
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(item.softurl))]
                    )
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function fn(_ref2) {
                  var item = _ref2.item
                  return [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          secondary: "",
                          disabled: !!_vm.loadingLogin,
                          loading: _vm.loadingLogin === item.insid
                        },
                        on: {
                          click: function click($event) {
                            return _vm.login(item)
                          }
                        }
                      },
                      [
                        _vm._v(" WP Dashboard "),
                        _c(
                          "v-icon",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              small: ""
                            }
                          },
                          [_vm._v("mdi-open-in-new")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          bottom: "",
                          left: "",
                          "offset-y": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function fn(_ref3) {
                                var on = _ref3.on,
                                  attrs = _ref3.attrs
                                return [
                                  _c(
                                    "gg-btn",
                                    _vm._g(
                                      _vm._b({}, "gg-btn", attrs, false),
                                      on
                                    ),
                                    [
                                      _vm._v(" Manage "),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1"
                                        },
                                        [_vm._v("mdi-chevron-down")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.showModal("password", item)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Update Admin Password")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.showModal("disable", item)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Disable All Plugins")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.showModal("delete", item)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Delete Installation")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("admin-password-modal", {
        attrs: {
          installation: _vm.selectedInstallation,
          opened: _vm.modals.password
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("password")
          }
        }
      }),
      _c("disable-plugins-modal", {
        attrs: {
          opened: _vm.modals.disable,
          installation: _vm.selectedInstallation
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("disable")
          }
        }
      }),
      _c("delete-modal", {
        attrs: {
          opened: _vm.modals.delete,
          installation: _vm.selectedInstallation
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("delete")
          },
          deleted: _vm.fetchInstallations
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }